import error_image from "assets/images/error_image.svg";
import { Link } from "react-router-dom";

interface Props {
  errorType: "400" | "404";
}

const errorContent = {
  "404": {
    title: "Oops! Page not found",
    description:
      "The page you're trying to access does not exist or may have been moved. Try going back to the home page.",
    digits: ["4", "image", "4"],
  },
  "400": {
    title: "Oops! Something went wrong",
    description:
      "Something went wrong with your request. Please try again or return to the home page.",
    digits: ["4", "image", "image"],
  },
};

const ErrorPage = ({ errorType }: Props) => {
  const content = errorContent[errorType];

  return (
    <article className="relative h-[100vh] flex flex-col justify-center items-center overflow-hidden pb-[5rem]">
      <section className="flex flex-col gap-5 text-center">
        <div className="flex gap-5 justify-center items-center text-[13rem] font-bold">
          {content.digits.map((item, index) =>
            item === "image" ? (
              <img key={index} src={error_image} alt="error" />
            ) : (
              <span key={index}>{item}</span>
            )
          )}
        </div>

        <h3 className="font-bold text-[2rem]">{content.title}</h3>

        <p>{content.description}</p>

        <div>
          <Link
            to="/"
            className="bg-[#3897F0] text-white px-10 py-2 font-bold rounded-lg"
          >
            Go to Homepage
          </Link>
        </div>
      </section>

      <section className="absolute h-[70vw] w-[70vw] bg-[#3897F0] rounded-full bottom-[-70rem]"></section>
    </article>
  );
};

export default ErrorPage;
